<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import {Modal, ModalBody, ModalHeader, Button, ModalFooter, Table, ButtonGroup, CustomInput} from 'sveltestrap';
    import Expander from '../components/Expander.svelte';
    import { selectedGroup } from '../store';
    import Search from '../components/Search.svelte';
    import http from '../api/http';
    import Validator from '../Helpers/Validator';
    import '../css/app.css'

    const dispatch = createEventDispatcher();

    const createMode = 'create';
    const deleteMode = 'delete';
    const editMode = 'edit';
    const removeMode = 'remove';
    const vesselAttributesUpdated = 'vesselAttributesUpdated';
    const modalToggled = 'modalToggled';

    let shown = false;
    let errorMessage = "";
    let successMessage = "";
    let attributeName = "";
    let attributeValue = "";
    let deleteAttributes = false;
    let removeAttributes = false;
    let vessels = [];
    let mode = createMode;
    let vesselAttributes = [];
    let addedAttributes = [];
    let searchTerm;
    let nameSearchResults = [];
    let selectedAttributes = [];
    let additionalVessels = [];
    let vesselsWithAttributesToRemove = [];
    let addAdditionalVessels = false
    let modeText = 'Create Attributes';
    let pageSearchTerm = "";
    let labelText = "No"
    let attributeToEdit;

    async function setMode(switchMode) {
        selectedAttributes = [];
        selectedAttributes = selectedAttributes;
        attributeToEdit = undefined;
        successMessage = "";
       if(switchMode == createMode){
          modeText = 'Create Attributes';
          mode = createMode;
       }
       else if(switchMode == deleteMode){
            modeText = 'Delete Attributes';
            mode = deleteMode;
            await GetVesselAttributes();
        }
        else if(switchMode == editMode){
            modeText = 'Edit Attributes';
            mode = editMode;
            await GetVesselAttributes();
        }
         else if(switchMode == removeMode){
            modeText = 'Remove Attributes From Vessel(s)'
            mode = removeMode;
       }
    }
    
    function toggle() {
        if(shown){
            vessels = [];
            shown = false;
            resetModal();
            dispatch(modalToggled);
        }
        else{
            shown = true;
        }
    }

    function toggleAddAdditionalVessels(){
        if(addAdditionalVessels){
            addAdditionalVessels = false;
            labelText = "No";
        }
        else{
            addAdditionalVessels = true;
            labelText = "Yes";
        }
    }

    function resetModal(){
        vessels = [];
        addedAttributes = [];
        selectedAttributes.forEach(attribute => {
            attribute.selected = false;
        });
        selectedAttributes = [];
        vesselsWithAttributesToRemove = [];
        searchTerm = "";
        errorMessage = "";
        deleteAttributes = false;
        removeAttributes = false;
        mode = createMode;
        modeText = 'Create Attributes';
        selectedAttributes = selectedAttributes;
        addedAttributes = addedAttributes;
        vessels = vessels;
        additionalVessels = [];
        addAdditionalVessels = false;
        attributeToEdit = undefined;
        successMessage = "";
    }

    async function GetVesselAttributes() {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/true/${$selectedGroup}`);
        vesselAttributes = await res.json();
    }

    async function validateDelete() {
        if(selectedAttributes.length > 0){
            deleteAttributes = true;
        }
        else{
            errorMessage = "Please select at least one attribute to delete.";
        }
    }

    async function validateRemove() {
        if(selectedAttributes.length > 0){
            removeAttributes = true;
        }
        else{
            errorMessage = "Please select at least one attribute to remove from the vessels.";
        }
    }

    async function deleteVesselAttributes() {
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/${$selectedGroup}`, selectedAttributes);
        if(res.status == 200){
            toggle();
            dispatch('vesselAttributesUpdated');
        }
        else{
            errorMessage = "There was an error deleting the attributes.";
        }
    }

    async function removeVesselAttributeLinks() {
        let vesselsAndAttributes = {
            vessels: vesselsWithAttributesToRemove,
            attributes: selectedAttributes
        }
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/link/${$selectedGroup}`, vesselsAndAttributes);
        if(res.status == 200){
            toggle();
            dispatch('vesselAttributesUpdated');
        }
        else{
            errorMessage = "There was an error removing attributes from the vessels.";
        }
    }

    async function editAttribute(attribute) {
        const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/${$selectedGroup}`, attribute);
        if(res.status == 200)
        {
            dispatch(vesselAttributesUpdated);
            GetVesselAttributes();
            vesselAttributes = vesselAttributes;
            successMessage = `Attribute '${attribute.name} | ${attribute.value}' successfully updated.`
        }
        else{
            errorMessage = "There was an error editing the attributes.";
        }
    }

    function validateAttributeField(fieldName, fieldValue){
        if(fieldValue.length > 100){
            errorMessage = `${fieldName} cannot be longer than 100 characters.`;
        }
        else if(Validator.regex(fieldValue,'[<>\+\-\.=%:]')){
            errorMessage = `${fieldName} cannot contain the following characters <>+-.=%:`;
        }
        else{
            errorMessage = "";
        }
    }

    export async function show(selectedVessels, search) {
        vessels = selectedVessels;
        shown = true;
        pageSearchTerm = search;
        if(pageSearchTerm != "" && selectedVessels.length > 0){
           await getAdditonalVessels();
        }
    }

    function createAttribute() {
        attributeName = searchTerm;
        let theAttribute ={
            name: attributeName,
            value: attributeValue
        }
        addedAttributes.push(theAttribute);
        addedAttributes = addedAttributes;
        attributeName = "";
        attributeValue = "";
    }

    function removeVesselAttribute(attribute) {
        addedAttributes = addedAttributes.filter(item => item !== attribute);
        addedAttributes = addedAttributes;
    }

    function selectAttribute(attribute, vessel) {
        let index = vesselsWithAttributesToRemove.findIndex(v => v.id === vessel.id);
        if(index === -1 && mode != deleteMode){
            vesselsWithAttributesToRemove.push(vessel);
        }
        if(selectedAttributes.includes(attribute)){
            attribute.selected = false;
            selectedAttributes = selectedAttributes.filter(item => item !== attribute);
            selectedAttributes = selectedAttributes;
        }
        else{
            attribute.selected = true;
            selectedAttributes.push(attribute);
            selectedAttributes = selectedAttributes;
        }
    }

    async function getAdditonalVessels(){
        var selectedVesselIds = "";
        vessels.forEach(vessel => {
                selectedVesselIds += vessel.id.toString() + ",";
            });  
        selectedVesselIds = selectedVesselIds.slice(0, -1);
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/minusselected/${selectedVesselIds}/${pageSearchTerm}/${$selectedGroup}`);
        if(res.status == 200){
            additionalVessels = await res.json();
        }
        else{
            errorMessage = "There was an error getting the vessels.";
        }
    }

    async function searchAttributeNames() {
        let searchResults  = document.getElementsByClassName("search-results")[0];
        if(searchTerm.length > 0){
            searchResults.style.display = "block";
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/search/name/${searchTerm.toLocaleLowerCase()}/${$selectedGroup}`);
            nameSearchResults = await res.json(); 
            validateAttributeField("Attribute Name", searchTerm);
        }
        else{
            searchResults.style.display = "none";
        }
    }

    async function resetSearch() {
        validateAttributeField("Attribute Name", attributeName);
        let searchResults = document.getElementsByClassName("search-results")[0];
        if(searchResults.style.display = "block"){
            searchResults.style.display = "none";
        }
    }

    async function setSearchTerm(string) {
        searchTerm = string;
        let searchResults = document.getElementsByClassName("search-results")[0];
        searchResults.style.display = "none";
        searchTerm = searchTerm;
    }

    async function confirmClicked() {
        if(addAdditionalVessels){
            vessels = vessels.concat(additionalVessels);
        }
        vessels.forEach(vessel => {
            vessel.attributes.push(...addedAttributes);
        });
        if(addedAttributes.length > 0){
            let res;
            if(vessels.length > 0)
            {
                res = await http.post(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/${$selectedGroup}`, vessels);
            }
            else
            {
                res = await http.post(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/attributeonly/${$selectedGroup}`, addedAttributes);
            }
            
            if(res.status == 200){
                toggle();
                dispatch('vesselAttributesUpdated');
            }
            else{
                errorMessage = "There was an error adding the attributes.";
            }
        }
        else{
            errorMessage = "You must add at least one attribute.";
        }
    }

    onMount(() => {
        GetVesselAttributes();
    });
</script>

<Modal size="xl" isOpen={shown} {toggle}>
    <ModalHeader {toggle}>
        <h5 class="m-0 font-weight-bold mt-2 mb-2">Manage Vessel Attributes</h5>
    </ModalHeader>
    <ModalBody>
        <div class="container">
        <div class="d-flex m-2">
            <h3 class="modalHeading">{modeText}</h3>
            <ButtonGroup class="ml-auto">
                <Button id="manage-vessel-attributes-create-button" color="primary" class="btnGrp" on:click={() => setMode(createMode)} active={mode == createMode}><i class="fa fa-plus"></i> Create</Button>
                <Button id="manage-vessel-attributes-edit-button" color="primary"  class="btnGrp" on:click={() => setMode(editMode)} active={mode == editMode}><i class="fa fa-pencil"></i> Edit</Button>
                <Button id="manage-vessel-attributes-remove-button" color="primary"  class="btnGrp" on:click={() => setMode(removeMode)} active={mode == removeMode}><i class="fa fa-minus"></i> Remove</Button>
                <Button id="manage-vessel-attributes-delete-button" color="primary" class="btnGrp" on:click={() => setMode(deleteMode)} active={mode == deleteMode}><i class="fa fa-trash"></i> Delete</Button>
            </ButtonGroup>
         </div>
        {#if mode == createMode}
            <div class="container">
                 <div class="row">
                    <p class="col">Attribute Name</p>
                    <p class="col">Attribute Value</p>
                    <p class="col"></p>
                </div>
                <div class="row">
                    <div class="col form-group">
                        <Search id="manage-vessel-attributes-name-search" bind:searchTerm type="text" placeholder="Attribute Name" on:input={()=> searchAttributeNames()} on:focusout={() => resetSearch()} />
                        <div class="search-results">
                            {#each nameSearchResults as result}
                                <div id="manage-vessel-attributes-name-result-{result}" class="result" on:mousedown={() => setSearchTerm(result)}>
                                    <p>{result}</p>
                                </div>
                            {/each}
                        </div>
                        <small>Select an existing attribute name or create a new one.</small>
                    </div>
                    <div class="col form-group">
                        <input id="manage-vessel-attributes-value-input" class="form-control" bind:value={attributeValue} type="text"  placeholder="Attribute Value" on:input={() => validateAttributeField("Attribute Value", attributeValue )} />
                    </div>
                    <div class="col form-group">
                        <button id="manage-vessel-attributes-create-button" on:click={() => createAttribute()} class="btn btn-outline-primary"  disabled={errorMessage != ""}>Add Attribute</button>
                     </div>
                </div> 
                {#each addedAttributes as attribute}
                    <div class="row">
                        <div class="col form-group">
                            <input class="form-control" bind:value={attribute.name} type="text" disabled />
                        </div>
                        <div class="col form-group">
                            <input class="form-control" bind:value={attribute.value} type="text" disabled/>
                        </div>
                        <div class="col form-group">
                            <button id="manage-vessel-attributes-remove-attribute-button-{attribute.name}:{attribute.value}" on:click={() => removeVesselAttribute(attribute)} class="btn btn-outline-danger">Remove Attribute</button>
                        </div>
                    </div> 
                {/each}
            </div>
            
            <h3 class="modalHeading">Currently Editing ({vessels.length}) Vessel(s)</h3>
            {#if vessels.length > 0}
                <Expander expanderTitle="Show ({vessels.length}) Vessels">
                    {#each vessels as vessel}
                        <div class="row">
                            <div class="form-group col vessel">
                                <input class="form-control" type="text" bind:value={vessel.name} disabled>
                            </div>
                        </div>
                    {/each}
                </Expander>
                {:else}
                <p class="text-warning">You are currently creating attributes with no vessels selected. <br>If you wish to apply attributes to vessels first ensure that you have selected the vessels you wish to apply attributes to. </p>
            {/if}
            {#if additionalVessels.length > 0}
                <div class="d-flex">
                    <h5 class="modalHeading">({additionalVessels.length}) vessels have been found matching search criteria, would you like to apply attributes to these vessels?</h5>
                    <div class="ml-auto">
                        <CustomInput type="switch" id="manage-vessel-attributes-additional-vessels-switch" on:change={() => toggleAddAdditionalVessels()} label={labelText}></CustomInput>
                    </div>
                </div>
                <Expander expanderTitle="Show ({additionalVessels.length}) Vessels">
                    {#each additionalVessels as vessel}
                        <div class="row">
                            <div class="form-group col vessel">
                                <input class="form-control" type="text" bind:value={vessel.name} disabled>
                            </div>
                        </div>
                    {/each}
                </Expander>
            {/if}
        {/if}

        {#if mode == editMode}
            {#if vesselAttributes.length > 0}
            <p class="text-warning">Editing attributes here will affect all vessels with those attributes attached to them.</p>
            <Table repsonsive>
                <thead>
                    <tr>
                        <th>Attribute Name</th>
                        <th>Attribute Value</th>
                    </tr>
                </thead>
                <tbody>
                    {#each vesselAttributes as attribute}
                        <tr id="manage-vessel-attributes-edit-row-{attribute.name}-{attribute.value}" class="pointer" on:mousedown={() => attributeToEdit = attribute}>
                            <td>{attribute.name}</td>
                            <td>{attribute.value}</td>
                        </tr>
                    {/each}
                </tbody>
                </Table>
                    {#if attributeToEdit != undefined}
                        <div class="row">
                            <p class="col">Attribute Name</p>
                            <p class="col">Attribute Value</p>
                            <p class="col"></p>
                        </div>
                        <div class="row">
                            <div class="col form-group">
                                <input id="manage-vessel-attributes-edit-input-name-{attributeToEdit.name}" class="form-control" bind:value={attributeToEdit.name} type="text" on:input={() => validateAttributeField("Attribute Name", attributeToEdit.name)} />
                            </div>
                            <div class="col form-group">
                                <input id="manage-vessel-attributes-edit-input-value-{attributeToEdit.value}" class="form-control" bind:value={attributeToEdit.value} type="text" on:input={() => validateAttributeField("Attribute Value", attributeToEdit.value)}/>
                            </div>
                            <div class="col form-group">
                                <button id="manage-vessel-attributes-edit-save-button" on:click={() => editAttribute(attributeToEdit)} disabled={errorMessage != ""} class="btn btn-outline-info">Save Changes</button>
                            </div>
                        </div> 
                    {/if}
                {:else}
                <p>There are currently no attributes to show.</p>
            {/if}
        {/if} 

        {#if mode == removeMode}
            {#if vessels.length > 0}
                {#each vessels as vessel }
                    {#if vessels.length > 1}
                        <Expander titleIcon="ship" expanderTitle="View {vessel.name} Attributes">
                            {#if vessel.attributes.length > 0}
                                <Table>
                                    <thead>
                                        <th></th>
                                        <th>Attribute Name</th>
                                        <th>Attribute Value</th>
                                    </thead>
                                    <tbody>
                                        {#each vessel.attributes as attribute}
                                            <tr>
                                                <td><input id="vessel-attribute-{attribute.id}-checkbox" type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute, vessel)}/></td>
                                                <td>{attribute.name}</td>
                                                <td>{attribute.value}</td>
                                            </tr>
                                        {/each}
                                    
                                    </tbody>
                                </Table>
                                {:else}
                                <p>{vessel.name} has no attributes.</p>
                            {/if}
                        </Expander>
                        {:else}
                         {#if vessel.attributes.length > 0}
                            <Table>
                                <thead>
                                    <th></th>
                                    <th>Attribute Name</th>
                                    <th>Attribute Value</th>
                                </thead>
                                <tbody>
                                    {#each vessel.attributes as attribute}
                                        <tr>
                                            <td><input id="vessel-attribute-{attribute.id}-checkbox" type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute, vessel)}/></td>
                                            <td>{attribute.name}</td>
                                            <td>{attribute.value}</td>
                                        </tr>
                                    {/each}
                                </tbody>
                            </Table>
                            {:else}
                            <p>{vessel.name} has no attributes.</p>
                         {/if}
                    {/if}
                {/each}
            
                {#if removeAttributes == true}
                    <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action will affect multiple vessels, attributes of this name will be removed from selected vessels. <br/> Are you sure you wish to proceed?</p>
                {/if}
                {:else}
                <p>There are currently no vessels selected.<br/>To remove attributes, first ensure you have selected vessels that you wish to remove attributes from.</p>
            {/if}
        {/if}

        {#if mode == deleteMode}
            {#if vesselAttributes.length > 0}
            <p class="text-warning">Deleting attributes here will affect all vessels with those attributes attached to them.</p>
                <Table repsonsive>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Attribute Name</th>
                            <th>Attribute Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each vesselAttributes as attribute}
                            <tr>
                                <td><input id="vessel-attribute-{attribute.id}-checkbox" type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute)}/></td>
                                <td>{attribute.name}</td>
                                <td>{attribute.value}</td>
                            </tr>
                        {/each}
                    </tbody>
                </Table>
                {#if deleteAttributes == true}
                    <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action will affect multiple vessels, attributes of this name will be deleted and cannot be undone. <br/> Are you sure you wish to proceed?</p>
                {/if}
                {:else}
                <p>No attributes to show.</p>
            {/if}
        {/if}
        <p class="text-danger">{errorMessage}</p>
        <p class="text-success">{successMessage}</p>
        </div>
    </ModalBody>
    <ModalFooter>
        {#if mode == createMode}
            <button id="vessel-attribute-create-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
            <button id="vessel-attribute-create-confirm-button" class="btn btn-primary" disabled={addedAttributes.length == 0 } on:click={() => confirmClicked()}>Confirm</button>
        {/if}
        {#if mode == editMode}
            <button id="vessel-attribute-edit-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
            <button id="vessel-attribute-edit-confirm-button" class="btn btn-primary" on:click={() => toggle()}>Confirm</button>
        {/if}
        {#if mode == deleteMode}
            {#if deleteAttributes == false}
                <button id="vessel-attribute-delete-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
                <button id="vessel-attribute-delete-validate-button" class="btn btn-danger" on:click={() => validateDelete()}>Delete Attributes</button>
                {:else}
                <button id="vessel-attribute-delete-stop-button" class="btn btn-outline-primary" on:click={() => deleteAttributes = false}>Cancel</button>
                <button id="vessel-attribute-delete-confirm-button" class="btn btn-danger" on:click={() => deleteVesselAttributes()}>Delete {selectedAttributes.length} Attributes</button>
            {/if}
        {/if}
        {#if mode == removeMode}
            {#if removeAttributes == false}
                <button id="vessel-attribute-remove-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
                <button id="vessel-attribute-remove-validate-button" class="btn btn-danger" on:click={() => validateRemove()}>Remove Attributes</button>
                {:else}
                <button id="vessel-attribute-remove-stop-button" class="btn btn-outline-primary" on:click={() => removeAttributes = false}>Cancel</button>
                <button id="vessel-attribute-remove-confirm-button" class="btn btn-danger" on:click={() => removeVesselAttributeLinks()}>Remove {selectedAttributes.length} Attributes From Vessel(s)</button>
            {/if}
        {/if}
    </ModalFooter>
</Modal>

<style>
    .vessel input{
        border-color: transparent;
    }
</style>
